import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import { Button, Divider } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import RecentNews from "./RecentNews";
import HomePageNews from "./News/HomePageNews";

export default function HomePageTopDiv() {
  const media = useMediaQuery("(max-width: 768px)");
  return (
    <div>
      {" "}
      {!media && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
            
        <Grid container spacing={2}>
          
          
            <container>
            <div style={{ padding: 10, marginTop: 20, }}>
              <Typography
                variant="h5"
                style={{ fontWeight: 700, fontSize: 20 }}
                gutterBottom
              >
                About the NSS Unit, Dispur College
              </Typography>
              <Typography
                variant="body2"
                style={{ textAlign: "justify", fontSize: 16 }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The National Service Scheme (NSS) Unit of Dispur College was established in the year 13.10.2001 with the aim of nurturing socially responsible and committed youth through community service and nation-building activities. The Unit is affiliated to the Gauhati University NSS Cell and functions under the guidance of the Programme Officer and in accordance with the norms and objectives laid down by the Ministry of Youth Affairs & Sports, Government of India as well as in consonance with the regulations and directives issued by the Regional Directorate of NSS, Guwahati. ....<Link to="/aboutus/about">Read More</Link>
                {/* <VideoHomePage viewTitle={false} /> */}
              </Typography>
            </div>
            </container>
            <div></div>
            {/* <div>
              <Divider
                orientation="left"
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  borderColor: "#ABB2B9",
                  paddingLeft: 50,
                }}
              >
                President's Message
              </Divider>
              <div
                style={{ width: "100%", position: "relative",  }}
              >
                <img
                  src="/images/pres-112.png"
                  className="img-wrap-image"
                />

                <div className="p-warp-image">
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{ textAlign: "justify", padding: 10, fontSize: 14 }}
                  >
                     It is with great pride and privilege that I welcome you to the official website of Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya (NSS), Eraligool. As an institution dedicated to academic excellence.....<Link to="/administrations/president"><a>Read more</a></Link>
                  </Typography>

                 
                </div>
              </div>
              <Divider
                orientation="left"
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  borderColor: "#ABB2B9",
                  paddingLeft: 50,
                }}
              >
                Principal's Message
              </Divider>
              <div
                style={{
                  width: "100%",
                  position: "relative",
                  minHeight: "10vh",
                  
                }}
              >
                <img
                  src="/images/principal_panditdeen.jpg"
                  className="img-wrap-image"
                />

                <div className="p-warp-image">
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{ textAlign: "justify", padding: 10, fontSize: 14 }}
                  >
                   I am pleased to announce the commencement of a new academic session 2024-2025 at Pandit Deendayal Upadhyaya Adarsha Mahavidyalaya (NSS), Eraligool, Sribhumi. Through collaboration with various stakeholders of the Mahavidyalaya........<Link to="/administrations/principal"><a>Read more</a></Link>
                  </Typography>

                 
                </div>
              </div>
            </div> */}

            <br />
            <br />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <div style={{ marginTop: 10,paddingTop:40, backgroundColor:'#D6EAF8' }}>
                  <Divider
                    orientation="left"
                    style={{
                      fontWeight: 700,
                      fontSize: 20,
                      borderColor: "#ABB2B9",
                      marginTop: "-20px",
                    }}
                  >
                    Notifications
                  </Divider>
                  <div style={{paddingLeft: 20, paddingRight: 10, paddingBottom: 10}}>
                  <HomePageNews
                    type="COLLEGE_ACADEMIC_NOTICE"
                    link="/notifications/academic"
                  /></div>
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                <div style={{ paddingTop: 40 }}>
                  <Divider
                    orientation="left"
                    style={{
                      fontWeight: 700,
                      fontSize: 20,
                      borderColor: "#ABB2B9",
                      marginTop: "-20px",
                    }}
                  >
                    News & Events
                  </Divider>
                  <HomePageNews
                    type="COLLEGE_EVENT"
                    link="/events"
                  />
                </div>
              </Grid> */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <div style={{ marginTop: 10,paddingTop:40, backgroundColor:'#D6EAF8'}}>
                  <Divider
                    orientation="left"
                    style={{
                      fontWeight: 700,
                      fontSize: 20,
                      borderColor: "#ABB2B9",
                      marginTop: "-20px",
                    }}
                  >
                    Messages from the Principal
                  </Divider>
                  <div
                style={{
                  width: "100%",
                  position: "relative",
                  minHeight: "38vh",
                  
                }}
              >
                <img
                  src="/images/principal.jpg"
                  className="img-wrap-image"
                />

                <div className="p-warp-image">
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{ textAlign: "justify", padding: 10, fontSize: 16 }}
                  >
                   It gives me immense pleasure to extend my heartfelt greetings to all members of the National Service Scheme (NSS) Unit of Dispur College. The NSS plays a vital role in shaping socially responsible citizens and fostering a spirit of selfless service among our students.
                  </Typography>
                  <Typography
                    variant="body2"
                    gutterBottom
                    style={{ textAlign: "justify", padding: 10, fontSize: 16 }}
                  >
                   Our College takes pride in the dedication, enthusiasm, and commitment exhibited by the NSS volunteers in organizing community service initiatives, awareness programs, and outreach activities. These endeavours not only contribute to the well-being of society but also cultivate leadership, empathy, and teamwork among our students....<Link to="/administrations/principal"><a>Read more</a></Link>
                  </Typography>
                 
                </div>
              </div>
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                <div style={{ paddingTop: 40 }}>
                  <Divider
                    orientation="left"
                    style={{
                      fontWeight: 700,
                      fontSize: 20,
                      borderColor: "#ABB2B9",
                      marginTop: "-20px",
                    }}
                  >
                    Downloads
                  </Divider>
                  <HomePageNews
                    type="COLLEGE_DOWNLOADS"
                    link="/students/downloads"
                  />
                </div>
              </Grid> */}
            </Grid>

            {/* <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Button
              style={{
                width: "80%",
                height: "60px",
                border: "solid",
                borderColor: "#443205",
                fontSize: 16,
                fontWeight: 700,
                color: "white",
                backgroundColor: "#443205",
                boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
              }}
            >
              New Voters' Link 1
            </Button>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Button
              style={{
                width: "80%",
                height: "60px",
                border: "solid",
                borderColor: "#443205",
                fontSize: 16,
                fontWeight: 700,
                color: "white",
                backgroundColor: "#443205",
                boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
              }}
            >
              New Voters' Link 2
            </Button>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Link to="/rti/home">
              <Button
                style={{
                  width: "80%",
                  height: "60px",
                  border: "solid",
                  borderColor: "#443205",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "white",
                  backgroundColor: "#443205",
                  boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
                }}
              >
                RTI Cell
              </Button>
            </Link>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Link to="/committees">
              <Button
                style={{
                  width: "80%",
                  height: "60px",
                  border: "solid",
                  borderColor: "#443205",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "white",
                  backgroundColor: "#443205",
                  boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
                }}
              >
                CELLS/ COMMITTEE
              </Button>
            </Link>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Link to="/iqac/feedback">
              <Button
                style={{
                  width: "80%",
                  height: "60px",
                  border: "solid",
                  borderColor: "#443205",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "white",
                  backgroundColor: "#443205",
                  boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
                }}
              >
                <a></a>FEEDBACK
              </Button>
            </Link>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Link to="/gallery/photo">
              <Button
                style={{
                  width: "80%",
                  height: "60px",
                  border: "solid",
                  borderColor: "#443205",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "white",
                  backgroundColor: "#443205",
                  boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
                }}
              >
                GALLERY
              </Button>
            </Link>
          </div>
          <div style={{ textAlign: "center", paddingTop: "5vh" }}>
            <Link to="/notifications/achievements">
              <Button
                style={{
                  width: "80%",
                  height: "60px",
                  border: "solid",
                  borderColor: "#443205",
                  fontSize: 16,
                  fontWeight: 700,
                  color: "white",
                  backgroundColor: "#443205",
                  boxShadow: "5px 5px 10px rgba(0,0,0,0.3)",
                }}
              >
                ACHIEVEMENTS
              </Button>
            </Link>
          </div> */}
          </Grid>
        </Grid>
      )}
      
    </div>
  );
}
